import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, importProvidersFrom, inject, NgModule } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { NotificationService } from '@shared/services/notifications/notifications.service';
import { SharedStore } from '@shared/store/shared.signal-store';
import { BaseAuthService, BaseCurrentUserStore, WAIT_TO_RESOLVE_ON_TIMEOUT } from '@stillmandigital/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import {
  balancesJugglerApiConfigurationProvider,
  bBookLpApiConfigurationProvider,
  coreApiConfigurationProvider,
  fineryApiConfigurationProvider,
  fireblocksApiConfigurationProvider,
  hiddenRoadApiConfigurationProvider,
  houseLpApiConfigurationProvider,
  mainBookLpApiConfigurationProvider,
  principalRiskLpApiConfigurationProvider,
  syntheticLpApiConfigurationProvider,
} from './auth/services/api-config.factory';
import { AuthInterceptor } from './auth/services/auth.interceptor';
import { AuthService } from './auth/services/auth.service';
import { LoadScriptHandler } from './error-handling/load-script-handler';

const LOADING_NOTIFICATION_DURATION_MS = 10_000;

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [AuthModule, BrowserModule, AppRoutingModule, BrowserAnimationsModule],
  providers: [
    coreApiConfigurationProvider,
    houseLpApiConfigurationProvider,
    fineryApiConfigurationProvider,
    fireblocksApiConfigurationProvider,
    principalRiskLpApiConfigurationProvider,
    bBookLpApiConfigurationProvider,
    hiddenRoadApiConfigurationProvider,
    mainBookLpApiConfigurationProvider,
    syntheticLpApiConfigurationProvider,
    balancesJugglerApiConfigurationProvider,
    {
      provide: BaseAuthService,
      useExisting: AuthService,
    },
    {
      provide: BaseCurrentUserStore,
      useExisting: SharedStore,
    },
    {
      provide: WAIT_TO_RESOLVE_ON_TIMEOUT,
      useFactory: () => {
        const notificationService = inject(NotificationService);

        return () =>
          notificationService.showErrorNotification(
            'Loading is taking longer than usual. Some data may be missing until it finishes loading.',
            undefined,
            LOADING_NOTIFICATION_DURATION_MS,
          );
      },
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    importProvidersFrom(MatNativeDateModule),
    {
      provide: ErrorHandler,
      useClass: LoadScriptHandler,
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [SharedStore],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
